export const EXTRA_QUERY_KEYS = {
  PRINT: ['commonDocsTablePrint'],
  EXPORT: ['commonDocsTableExport']
};
